export default "__VITE_ASSET__0e2c0a9b__"